import { useState } from "react";
import { NumericFormat } from 'react-number-format';

const BoxTotal = ({ title, value, bgColor, icon, prefix = '' }) => {
    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    return (
        <div className={`card-overview ${bgColor} rounded-3 mb-3`}>
            <div className="d-flex justify-content-between">
                <div className="py-3 ps-3 text">
                    <small>{title}</small><br />
                    <NumericFormat
                        value={value}
                        displayType={'text'}
                        thousandSeparator={true}
                        className="bg-transparent p-0 fw-bold"
                        prefix={prefix}
                        renderText={(value, props) => <span {...props}>{value}</span>} />
                </div>
                <div className="icon">
                    {icon}
                </div>
            </div>
        </div>
    );
}

export default BoxTotal;
